import { Stack, Typography } from "@mui/material"

export function PdfTaskMetadataItem({ item }) {
    return (
        <Stack direction="row" spacing={0.5}>
            <Typography sx={{ fontSize: "10px", color: "#7b8794" }}>{item.label}:</Typography>
            <Typography sx={{ fontSize: "10px", color: "#374151" }}>{item.value}</Typography>
        </Stack>
    )
}
